<template>
  <div>
    <input-select
      v-model="form.participanteContaId"
      :options="opcoes.participanteConta"
      :loading="loadingParticipanteConta"
      class="col-12 col-md-12 pt-0 mt-0 pl-0 pr-0"
      hide-details
    />
  </div>
</template>

<script>
import ParticipanteService from '@/common/services/cadastros/ParticipanteService';
import { DropdownModel } from '@/common/models/geral/DropdownModel';
import { AcreditacaoModel } from '@/common/models/cadastros/AcreditacaoModel.js';

export default {
  props: {
    instrumentosIds: {
      type: Array,
      default: () => [],
    },
    criterio: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      opcoes: {
        participanteConta: [],
      },
      form: new AcreditacaoModel({}),
      loadingParticipanteConta: false,
    };
  },
  watch: {
    'form.participanteContaId'(valor) {
      if (!valor) return;
      let criterios = this.$store.getters['criterios/getCriterios'];
      const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia);

      if (itemEncontrado) {
        console.log("(itemEncontrado)", valor);
        itemEncontrado.participanteContaId = valor
        itemEncontrado.participanteConta = { id: valor };
        this.$store.dispatch('criterios/updateCriterio', { updatedCriterio: itemEncontrado });
        return
      }

      this.criterio.participanteContaId = valor
      this.criterio.participanteConta = { id: valor };

      this.$store.dispatch('criterios/updateCriterio', { updatedCriterio: this.criterio });

    }
  },
  mounted(){
    this.buscarParticipanteConta();
    this.setup()
  },
  methods: {
    setup(){
      let criterios = this.$store.getters['criterios/getCriterios']
      const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia)

      if(itemEncontrado) {
          this.form.participanteContaId = itemEncontrado.participanteConta.id??itemEncontrado.participanteContaId
          itemEncontrado.participanteContaId = this.form.participanteContaId
          itemEncontrado.participanteConta = { id: this.form.participanteContaId };
          this.$store.dispatch('criterios/updateCriterio', { updatedCriterio: itemEncontrado });
      }
    },
    buscarParticipanteConta() {
      this.loadingParticipanteConta = true;
      ParticipanteService.listar({ flagParticipanteConta: true }).then((res) => {
        this.opcoes.participanteConta = new DropdownModel(res.data.items, 'apelido');
        this.loadingParticipanteConta = false;
      });
    }
  },
};
</script>
